import { createEmptyState } from 'data/createRandomState';
import {
  addUpdateJournalEntry,
  removeJournalEntries,
  setJournalStatus,
} from 'utils/stateToState';
import {
  JOURNAL_ADD_UPDATE,
  JOURNAL_REMOVE,
  JOURNAL_POST,
  JOURNAL_UNPOST,
} from 'constants/actionTypes';

export default function journal(state = createEmptyState().journal, action) {
  switch (action.type) {
    case JOURNAL_ADD_UPDATE: {
      const { journalEntry } = action;
      return addUpdateJournalEntry(state, journalEntry);
    }
    case JOURNAL_REMOVE: {
      const { entryId } = action;
      return removeJournalEntries(state, new Set([entryId]));
    }
    case JOURNAL_POST: {
      const { entryId } = action;
      return setJournalStatus(state, entryId, true);
    }
    case JOURNAL_UNPOST: {
      const { entryId } = action;
      return setJournalStatus(state, entryId, false);
    }
    default:
      return state;
  }
}
